require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2007-04-18-wednesday.json") })
        }
      }, "path---articles-2007-04-18-wednesday");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2007-04-18-wednesday!./.cache/json/articles-2007-04-18-wednesday.json
// module id = 506
// module chunks = 231608221292675